import { AfterViewInit, Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { UserService } from "src/app/_services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackbarService } from "src/app/_services/snackBar.service";
import { Observable, Observer, Subscription, fromEvent, merge, of } from "rxjs";
import { catchError, filter, map, take, tap } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackBarErrorComponent } from "../snack-bar-error/snack-bar-error.component";
import { GlobalService } from "src/app/_services/global.service";
import { TranslateService } from "@ngx-translate/core";
import "moment-timezone";
import * as moment from "moment";
var platform = require("platform");
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { TabSyncService } from 'src/app/_services/tab-sync.service';
declare var $: any;
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: UntypedFormGroup;
  passwordType: string;
  rememberMe: boolean;
  onLine;
  role;
  currLang;
  loginDisplay = false;
  activeAccounts = [];
  loginMicrosoftFlag = false;
  mircrosoftError = ''
  // Login OTP state (first time login / internal staff login)
  showLoginOtpModal = false;
  loginOtpUserId: number = null;
  loginOtpType: string = null;
   subscriptions: Subscription = new Subscription();
  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private snackBar: SnackbarService,
    private global: GlobalService,
    private translate: TranslateService,
    private msalService: MsalService,
    private authService: MsalService, private msalBroadcastService: MsalBroadcastService,
    private tabSyncService: TabSyncService
  ) { 
    //console.log('(c)login_(f)constructior_(L)46');
  }

  ngOnInit(): void {
    //console.log('(c)login_(f)ngOnInit_(L)51');
    //get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    //console.log('(c)login_(f)ngOnInit/vh calculated_(L)53');
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    //console.log('(c)login_(f)ngOnInit/vh property set_(L)56');

    // We listen to the resize event
    window.addEventListener("resize", () => {
    //console.log('(c)login_(f)ngOnInit/resize event fired_(L)60');

      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      //console.log('(c)login_(f)ngOnInit/resize event finished_(L)65');
    });

    // hide chat bot
    $("#fc_frame").hide();
    
    this.global.getLang().pipe(take(1)).subscribe((lng) => {
      //console.log('(c)login_(f)getLang_(L)72' , lng);
      this.currLang = lng || "en";
      this.global.setLang(this.currLang);  
      this.route.queryParams.pipe(take(1)).subscribe((param) => {
        //console.log('(c)login_(f)route.queryParams_(L)76' , param);
        if (param.token) {
          // the link replaces the session of every open tab, so ask first when other tabs are signed in
          this.tabSyncService.confirmLink().then((confirmed) => {
            if (!confirmed) {
              // stay on the plain login page, the other tabs keep their session
              this.router.navigate(['/login']);
              return;
            }
            localStorage.clear();
            // this.global.setLang(this.currLang);
            this.userService.createToken(param.token).subscribe((res: any) => {
              
              if (res) {
                // already confirmed above, and the clear() has signed the other tabs out
                this.afterLoginProcess(res, true);
              }
            },(err=>{
              let errorMsg;
              errorMsg = err?.error?.message
              this.snackBar.setSnackBarMessage(errorMsg);
              this._snackBar.openFromComponent(SnackBarErrorComponent, {
                duration: 5000,
                horizontalPosition: "center",
                verticalPosition: "top",
              });
            }));
          });
        }
      });
    });
    

    this.createOnline$().subscribe((isOnline) => {
      //console.log('(c)login_(f)createOnline$_(L)101' , isOnline);
      this.onLine = isOnline;
    });

    this.passwordType = "password";
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl("", [
        Validators.required,
        Validators.email,
        Validators.pattern(
          "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
        ),
      ]),
      password: new UntypedFormControl("", Validators.required),
    });
    this.subscribeToMicrosoftResults();
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.hideChat();
    // }, 3000);
  }

  hideChat() {
    //console.log('(c)login_(f)hideChat_(L)126');
    document.getElementById("fc_frame").style.display = "none";
    //console.log('(c)login_(f)hideChat_(L)128');
  }

  async afterLoginProcess(res, skipTabConfirm = false): Promise<boolean> {
    // this login will reload or sign out the user's other open tabs, ask first
    if (!skipTabConfirm && !(await this.tabSyncService.confirmLogin(res.id))) {
      return false;
    }
    localStorage.setItem("token", res.token);
    localStorage.setItem("loginAs", res.login_as);
    localStorage.setItem("userId", res.id);
    localStorage.setItem("userName", res.name);
    localStorage.setItem("activation", res.is_active);
    localStorage.setItem("lang", this.currLang);
    localStorage.setItem("userMail", res.email);
    localStorage.setItem("userPhone", res.phone);
    localStorage.setItem("userCountryCode", res.country_code);
    localStorage.setItem("nat", res.national_id);
    localStorage.setItem("sideBarWidth", '16.6%');
    this.switchObserverMode(res);
    /**
     * SCHOOL SELECTION FEATURE - LOGIN FLOW
     * 
     * After successful login, we need to:
     * 1. Get all schools the user has access to
     * 2. Filter schools based on the logged-in role (this.role)
     * 3. Select the first school from the filtered list
     * 4. Store school information in localStorage for use throughout the app
     * 
     * Note: The filtering here is based on the user's logged-in role (e.g., 'manager').
     * A user may have different roles in different schools (e.g., 'school_admin' in School A
     * and 'manager' in School B). This initial filter shows only schools where the user has
     * the role they logged in with. Later in the layout component, we show all schools where
     * the user has admin/manager roles regardless of which role they logged in with.
     */
    this.userService.getSchoolInfo().subscribe((res: any) => {
      //console.log('(c)login_(f)afterLoginProcess/userService.getSchoolInfo_(L)145');
      this.userService.userPlan =
        res[0].subscription_plan.is_free == 0 ? "paid" : "free";
      this.role = localStorage.getItem("loginAs");
      let selectedSchools = [];
      
      /**
       * Filter selected schools to only include those where the user has the logged-in role.
       * Example: If user logged in as 'manager', only show schools where they have 'manager' role.
       * This ensures the initial school selection matches the user's logged-in role context.
       */
      selectedSchools = res.filter(
        (school) =>
          school.roles.filter((role) => role.name === this.role).length
      );
      
      /**
       * Store the selected school information in localStorage.
       * - schoolId: Used throughout the app to identify the current school context
       * - lastShcoolSelectedId: Used by layout component to restore school selection after page reload
       * IMPORTANT: We set lastShcoolSelectedId here so that when the layout component's
       * getSchools() function runs, it can find and select the same school that was chosen
       * during login, preventing conflicts between login selection and layout selection.
       */
      localStorage.setItem("schoolId", selectedSchools[0].id);
      localStorage.setItem('lastShcoolSelectedId', selectedSchools[0].id);
      localStorage.setItem("schoolName", selectedSchools[0].name);
      localStorage.setItem("schoolImage", selectedSchools[0].image_path);
      localStorage.setItem("schoolLat", selectedSchools[0].lat);
      localStorage.setItem("schoolLong", selectedSchools[0].long);
      localStorage.setItem("schoolCountryCode", selectedSchools[0]?.country_code);
      switch (this.role) {
        case "supervisor":
          localStorage.setItem("studentStatus", "with_supervisor");
          break;
        case "teacher":
          localStorage.setItem("studentStatus", "with_teacher");
          break;
        //  this case for now to pass the admin and open the popoup with no action at all until we take approval on how to handle deliver by admin
        case "school_admin":
        case "manager":
          localStorage.setItem("studentStatus", "ADMIN");
          break;
      }
      // same landing page the login redirect guard uses for a returning user
      this.router.navigateByUrl(this.userService.getHomeUrl(this.role));
    });
    return true;
  }

  createOnline$() {
    return merge<any>(
      fromEvent(window, "offline").pipe(map(() => false)),
      fromEvent(window, "online").pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        //console.log('(c)login_(f)createOnline$_(L)197');
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }

  togglePassword() {
    this.passwordType = this.passwordType === "text" ? "password" : "text";
  }

  keyDownFunc(event) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  login() {
    let formData = new FormData();
    formData.append("email", this.loginForm.value["email"]);
    formData.append("password", this.loginForm.value["password"]);
    formData.append("platform", "web");
    this.userService.login(formData).subscribe(
      (res: any) => {
        //console.log('(c)login_(f)login_(L)221' , res);
        this.afterLoginProcess(res);
      },
      (error) => {
        const body = error?.error;
        // let body:any = {requires_first_time_login_otp: true, user_id: 123};
        if (body?.requires_first_time_login_otp || body?.requires_internal_staff_login_otp) {
          this.loginOtpUserId = body?.user_id;
          // the backend tells us which otp flow this is , fall back to the flag that triggered it
          this.loginOtpType = body?.otp_type
            ? body.otp_type
            : (body?.requires_internal_staff_login_otp ? 'internal_staff_login' : 'first_time_login');
          this.showLoginOtpModal = true;
          return;
        }
        let errorMsg;
        errorMsg = !this.onLine
          ? "login.connection-error"
          : (errorMsg = error?.error?.message
            ? error?.error?.message
            : "auth-error");
        errorMsg = this.translate.instant(errorMsg);
        this.snackBar.setSnackBarMessage(errorMsg);
        this._snackBar.openFromComponent(SnackBarErrorComponent, {
          duration: 5000,
          horizontalPosition: "center",
          verticalPosition: "top",
        });
      }
    );
  }

  // Called when OTP is verified successfully in modal
  onLoginOtpVerified(res: any) {
    this.showLoginOtpModal = false;
    // internal staff login returns the logged in user directly from the verify endpoint
    if (res?.type === 'internal_staff_login' && res?.user) {
      this.afterLoginProcess(res.user);
      return;
    }
    // Otherwise, fallback: retry the original login
    this.login();
  }

  loginWithToken(token:string) {
    this.loginMicrosoftFlag = true;
    let body:any = {};
    body = {
      partner:"microsoft",
      platform:"web",
      token:token
    }
  
    this.userService.loginViaToken(body).subscribe(
      (res: any) => {
        this.afterLoginProcess(res).then((loggedIn) => {
          if (loggedIn) {
            localStorage.setItem('signedInViaMicrosoft', 'true')
          }
        });
        this.loginMicrosoftFlag = false;
      },
      (error) => {
        this.loginMicrosoftFlag = false;
        this.mircrosoftError = error?.error?.message
        $("#microsoft-error-popup").modal('show');
      }
    );
  }

  getValidationMessage(control: string) {
    let errorMsg;
    if (this.loginForm.controls[control].errors) {
      const fieldName = this.translate.instant("login." + control);
      const requiredText = this.translate.instant("login.required");
      const invalidText = this.translate.instant("login.invalid");
      errorMsg = this.loginForm.controls[control].errors.required
        ? `${fieldName + requiredText}`
        : `${control + invalidText}`;
    }
    return errorMsg;
  }

  toggleRemeber() {
    this.rememberMe = !this.rememberMe;
    localStorage.setItem("rememberMe", JSON.stringify(this.rememberMe));
  }

  openForgetPassword() {
    this.router.navigateByUrl("forgot-password");
  }


  loginWithMicrosoft() {
    this.loginMicrosoftFlag = true;
    sessionStorage.clear();
    setTimeout(() => {
      this.msalService.loginRedirect();
    }, 100);
    // this.msalService.acquireTokenPopup();
  }


  subscribeToMicrosoftResults() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: any) => {
        console.log('sso', result);
        this.loginWithToken(result?.payload?.accessToken)
        // this.logOutMicrosoft();
        // const payload = result.payload as AuthenticationResult;
        // this.authService.instance.setActiveAccount(payload.account);
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      })
  }

  setLoginDisplay() {
    // this.activeAccounts = this.authService.instance.getAllAccounts();
    console.log('activeAccounts', this.activeAccounts);

  }

  logOutMicrosoft() {
    this.resetToaster();
    this.msalService.logoutPopup().pipe(
      tap(() => {
        // Handle successful logout
        console.log('Logged out successfully');
        // Optionally, redirect to login page or refresh view
        this.router.navigate(['/login']);
      }),
      catchError(error => {
        // Handle errors during logout
        console.error('Logout error:', error);
        return of(null); // Return an empty observable to complete the stream
      })
    ).subscribe();
  }

  resetToaster(){
  this.mircrosoftError = ''
  $("#microsoft-error-popup").modal('hide');
  }

  ngOnDestroy(): void {
    this.resetToaster();
  }

  switchObserverMode(res){
    if(res?.login_as == 'teacher' || res?.login_as == 'supervisor'){
      let observerMode = res?.schools[0]?.pivot?.observer_mode == 1 ? true:false;
      localStorage.setItem('observer_mode', JSON.stringify(observerMode));
    }else{
      localStorage.removeItem('observer_mode');
    }
  }
}
